import React, { useCallback, useEffect, useState } from 'react';
import { RefreshCw, Search } from 'lucide-react';
import Loader from '../Loader';
import { Badge, Device, Empty, HScroll, Pager } from './UpUi';
import { EVENTS, dateTime } from './format';

/** Journal de tous les comptes (connexions, échecs, blocages, actions admin…) : les 20 derniers événements par user. */
const UpLogs = ({ pApi, onOpen, reloadKey }) => {
    const [page, setPage] = useState(1)
    const [event, setEvent] = useState('')
    const [search, setSearch] = useState('')
    const [q, setQ] = useState('')
    const [data, setData] = useState(null)
    const [error, setError] = useState('')

    const load = useCallback(async () => {
        setError('')
        try { setData(await pApi.get('/logs', { page, perPage: 50, ...(event && { event }), ...(q && { q }) })) } catch (e) { setError(e.message) }
    }, [pApi, page, event, q])
    useEffect(() => { load() }, [load, reloadKey])
    useEffect(() => {
        const t = setTimeout(() => { setQ(search.trim()); setPage(1) }, 350)
        return () => clearTimeout(t)
    }, [search])

    return (
        <div>
            <div className='up-toolbar'>
                <div className='up-search'>
                    <Search size={16} />
                    <input placeholder='Email ou IP…' value={search} onChange={(e) => setSearch(e.currentTarget.value)} />
                </div>
                <select value={event} onChange={(e) => { setEvent(e.currentTarget.value); setPage(1) }}>
                    <option value=''>Tous les événements</option>
                    {Object.entries(EVENTS).map(([id, ev]) => <option key={id} value={id}>{ev.label}</option>)}
                </select>
                <button className='btn cw up-icon-btn' onClick={load} title='Actualiser'><RefreshCw size={15} /></button>
            </div>
            {error && <p className='up-error'>{error}</p>}
            {!data && !error ? <div className='up-loading'><Loader /></div> : data && (
                <>
                    <p className='up-count'><b>{data.total}</b> événement{data.total > 1 ? 's' : ''}</p>
                    <HScroll>
                        <div className='up-table up-table-alllogs'>
                            <div className='up-thead'><span>Date</span><span>User</span><span>Événement</span><span>Appareil · IP</span></div>
                            {data.items.map((l) => (
                                <div key={l.id} className='up-row' onClick={() => onOpen(l.userId)}>
                                    <span>{dateTime(l.at)}</span>
                                    <span className='truncate' title={l.email}>{l.email}</span>
                                    <span>
                                        <Badge tone={EVENTS[l.event]?.tone}>{EVENTS[l.event]?.label || l.event}</Badge>
                                        {l.detail && <small className='up-detail'>{l.detail}</small>}
                                    </span>
                                    <span><Device device={l.device} ip={l.ip} /></span>
                                </div>
                            ))}
                            {!data.items.length && <Empty>Aucun événement</Empty>}
                        </div>
                    </HScroll>
                    <Pager page={data.page} pages={data.pages} onPage={setPage} />
                </>
            )}
        </div>
    )
}

export default UpLogs;
